/** The same audio control for server-rendered course cards and dynamic practice cards. */
export const COURSE_PLAY_PATH = "M8 4.5v15L21 12z";
export function createCoursePlayButton(doc, src, label = "Play") {
  if (!src) return null;
  const button = doc.createElement("button");
  button.type = "button"; button.className = "ll-course-play";
  button.dataset.llAudio = src; button.setAttribute("aria-label", label);
  const svg = doc.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("viewBox", "0 0 24 24"); svg.setAttribute("aria-hidden", "true");
  const path = doc.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("d", COURSE_PLAY_PATH); path.setAttribute("fill", "currentColor");
  svg.append(path); button.append(svg);
  return button;
}
